<template>
    <span ref="triggerEl">
        <slot />
    </span>
</template>

<script>
import { Tooltip } from "bootstrap";

export default {
    name: "BootstrapTooltip",
    props: {
        content: { type: String, required: true },
        placement: {
            type: String,
            default: "top",
            validator: (v) =>
                ["top", "bottom", "left", "right", "auto"].includes(v),
        },
        trigger: { type: String, default: "hover focus" }, // e.g. 'click', 'manual'
        customClass: { type: String, default: "" },
    },
    data() {
        return { tooltipInstance: null };
    },
    watch: {
        content(newVal) {
            if (this.tooltipInstance) {
                this.tooltipInstance.setContent({ ".tooltip-inner": newVal });
            }
        },
    },
    mounted() {
        this.tooltipInstance = new Tooltip(this.$refs.triggerEl, {
            title: this.content,
            placement: this.placement,
            trigger: this.trigger,
            customClass: this.customClass,
        });
    },
    beforeUnmount() {
        if (this.tooltipInstance) {
            this.tooltipInstance.dispose();
            this.tooltipInstance = null;
        }
    },
};
</script>